import { HStack } from "../../../../../ui/hstack";
import Chip from "../Chip";
import type { FieldControlProps } from "../fieldTypes";

/** Pick several. Once the ceiling is reached the rest stop responding rather than
 * silently swapping a pick out. */
const MultiChipsField = ({
  field,
  value,
  onChange,
  disabled,
}: FieldControlProps) => {
  const picked = Array.isArray(value) ? value : [];
  const full =
    field.maxSelections !== null && picked.length >= field.maxSelections;

  const toggle = (option: string) => {
    const next = picked.includes(option)
      ? picked.filter((item) => item !== option)
      : [...picked, option];
    onChange(next.length ? next : undefined);
  };

  return (
    <HStack
      role="group"
      aria-label={field.label}
      className="flex-row flex-wrap gap-2"
    >
      {field.options.map((option) => {
        const selected = picked.includes(option.value);
        return (
          <Chip
            key={option.value}
            role="checkbox"
            selected={selected}
            disabled={disabled || (full && !selected)}
            onPress={() => toggle(option.value)}
          >
            {option.label}
          </Chip>
        );
      })}
    </HStack>
  );
};

export default MultiChipsField;
